export default "__VITE_ASSET__20be1e37__"